import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { ExtraAppValue } from "../../../services/api/instances/extraAppApi/types";
import type { ExtraAppState } from "./types";

const initialState: ExtraAppState = {
  appValue: null,
  isLoading: false,
};

const extraAppSlice = createSlice({
  name: "extraApp",
  initialState,
  reducers: {
    setExtraAppValue: (state, action: PayloadAction<ExtraAppValue | null>) => {
      state.appValue = action.payload;
    },
  },
});

export const extraAppReducers = extraAppSlice.reducer;
export const { setExtraAppValue } = extraAppSlice.actions;
